import * as SplitSettingsConstants from './SplitSettingsConstants';
import { BuyerSplitSettingState, SplitScenarioSettingsMap } from './BuyerSplitSettingTypes';
import { BuyerSplitSetting, SplitScenario, BuyerGroup, Buyer } from '../../../types';

export default function(
  state = SplitSettingsConstants.DEFAULT_STATE,
  action: any,
): BuyerSplitSettingState {
  let returnState: BuyerSplitSettingState = state;


  switch (action.type) {
    case SplitSettingsConstants.SplitSettingsActionTypes.LOADING_SETTINGS:
      returnState = {
        ...state,
        currentSplitScenario: { ...state.currentSplitScenario },
        loadStatus: 1,
      };
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.FAILED_SETTINGS:
      returnState = {
        ...state,
        currentSplitScenario: { ...state.currentSplitScenario },
        loadStatus: 0,
      };
      break;
    case SplitSettingsConstants.SplitSettingsActionTypes.LOAD_SETTINGS_ERROR:
      returnState = {
        ...state,
        ...SplitSettingsConstants.DEFAULT_STATE,
        currentSplitScenario: { ...state.currentSplitScenario },
      };
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.LOADED_BUYER_GROUPS:
      let activeBuyerGroups: Array<BuyerGroup> = action.payload;

      let buyerGroups: Array<BuyerGroup> = Object.assign(
        {},
        ...activeBuyerGroups.map(b => ({ [b.BuyerGroupId]: b })),
      );

      returnState = { ...state, buyerGroups: buyerGroups };
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.LOADED_SPLIT_SCENARIOS:
      let splitScenarios: Array<SplitScenario> = action.payload;
      let splitScenarioMap: Array<SplitScenario> = Object.assign(
        {},
        ...splitScenarios.map(s => ({ [s.SplitScenarioId]: s })),
      );

      returnState = { ...state, splitScenarios: splitScenarioMap };
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.LOADED_BUYER_SPLIT_SCENARIOS:
      returnState = { ...state, buyerSplitScenarios: action.payload };
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.LOADED_SETTINGS:
      /** organize split settings by scenario  */
      let ByScenarios: SplitScenarioSettingsMap = {};

      state.buyerSplitScenarios.forEach((splitSetting: BuyerSplitSetting) => {
        if (typeof ByScenarios[splitSetting.SplitScenarioId] === 'undefined') {
          ByScenarios[splitSetting.SplitScenarioId] = [];
        }

        ByScenarios[splitSetting.SplitScenarioId].push(splitSetting);
      });

      let currentSplitScenario = state.currentSplitScenario;
      if (state.currentSplitScenario.id === 0) {
        currentSplitScenario.id = Object.values(state.splitScenarios)[0].SplitScenarioId;
        currentSplitScenario.form = ByScenarios[currentSplitScenario.id];
        currentSplitScenario.orig = null;
      }

      let loadedSplitTotal: number = 0;
      currentSplitScenario.form.forEach((split: BuyerSplitSetting) => {
        loadedSplitTotal += isNaN(split.SplitValue) ? 0 : split.SplitValue * 1 ;
      });

      returnState = {
        ...state,
        loadStatus: 2,
        byScenarios: ByScenarios,
        currentSplitScenario: { ...currentSplitScenario, totalSplits: loadedSplitTotal },
      };
      break;
    //
    case SplitSettingsConstants.SplitScenarioSelectorActions.SPLIT_SCENARIO_CHANGE:
      let newId = state.currentSplitScenario.id;
      let newData = state.currentSplitScenario.form;

      if (newId !== action.scenarioId) {
        newData =
          state.byScenarios[action.scenarioId] !== undefined &&
          state.byScenarios[action.scenarioId] !== null
            ? [...state.byScenarios[action.scenarioId]]
            : [];
        newId = action.scenarioId;
      }

      let totalSplit: number = 0;
      newData.forEach((split: BuyerSplitSetting) => {
        split.SplitValue = isNaN(split.SplitValue) ? 0 : split.SplitValue;
        totalSplit += split.SplitValue;
      });

      returnState = {
        ...state,
        currentSplitScenario: {
          ...state.currentSplitScenario,
          id: newId,
          form: newData,
          orig: null,
          totalSplits: totalSplit,
        },
        editEntry: null,
      };
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.CANCEL_EDITING:
      returnState = {
        ...state,
        editEntry: null,
      };
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.CREATE_BUYER_GROUP_TO_SPLIT_SCENARIO:
      //saveFormResetState(state);

      //add the payload then return everything
      /* returnState = currentSplitScenarioState(
        [...state.currentSplitScenario.form, action.payload],
        state,
        action,
      ); */
      returnState = {
        ...state,
        editEntry: { ...SplitSettingsConstants.emptySelection },
      };
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.EDIT_BUYER_GROUP_ON_SPLIT_SCENARIO:
      //saveFormResetState(state);

      //add the payload then return everything
      /* returnState = currentSplitScenarioState(
        [...state.currentSplitScenario.form, action.payload],
        state,
        action,
      ); */

      returnState = {
        ...state,
        editEntry: action.payload,
      };
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.DEL_BUYER_GROUP_TO_SPLIT_SCENARIO:
      saveFormResetState(state);

      //remove the matching item then return then rest of it
      returnState = currentSplitScenarioState(
        [...state.currentSplitScenario.form].filter(
          (splitSetting: BuyerSplitSetting) =>
            splitSetting.SplitScenarioBuyerGroupId !== action.SplitScenarioBuyerGroupId ||
            (splitSetting.BuyerGroupId !== action.BuyerGroupId &&
              splitSetting.BuyerId !== action.BuyerId),
        ),
        state,
        action,
      );

      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.SAVE_BUYER_GROUP_TO_SPLIT_SCENARIO: //SplitSettingsConstants.SplitSettingsActionTypes.SPLIT_VALUE_MODIFIED:
      saveFormResetState(state);

      let newForm = [ ...state.currentSplitScenario.form ];

      //console.log("Save ", action.payload)

      let updated:boolean = false;
      newForm.forEach((item, idx, arr) => {
        if (
          item.BuyerGroupId === action.payload.BuyerGroupId &&
          item.BuyerId === action.payload.BuyerId
        ) {
          item.SplitValue = parseInt(action.payload.SplitValue);
          updated = true;
        }
      });

      if( !updated ){
        //insert
        newForm = [...newForm, action.payload];
      }

      returnState = currentSplitScenarioState(newForm, state, action);

      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.SPLIT_SETTINGS_RESET:
      let restoredForm =
        state.currentSplitScenario.orig !== null ? [...state.currentSplitScenario.orig] : [];

      clearFormResetState(state);
      returnState = currentSplitScenarioState(restoredForm, state, action);
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.SAVING_SPLIT_SETTINGS:
      returnState = {
        ...state,
        currentSplitScenario: {
          ...state.currentSplitScenario,
          formState: SplitSettingsConstants.FORM_STATE.LOCKED,
        },
      };
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.SAVE_SPLIT_SETTINGS:
      returnState = {
        ...state,
        currentSplitScenario: {
          ...state.currentSplitScenario,
          orig: null,
          formState: SplitSettingsConstants.FORM_STATE.OPEN,
        },
      };
      break;
    //
    case SplitSettingsConstants.SplitSettingsActionTypes.FAILED_SPLIT_SETTINGS:
      returnState = {
        ...state,
        currentSplitScenario: {
          ...state.currentSplitScenario,
          formState: SplitSettingsConstants.FORM_STATE.FAILED_SUBMIT,
          formMessages: [action.payload.reason],
        },
      };
      break;
    //
    default:
    //return state;
  }

  return returnState;
}

const saveFormResetState = (state: BuyerSplitSettingState) => {
  if (state.currentSplitScenario.orig === null) {
    state.currentSplitScenario.orig = JSON.parse(JSON.stringify(state.currentSplitScenario.form)); //[ ...state.currentSplitScenario.form ];
    /* for(let i:number = 0; i < state.currentSplitScenario.form.length; i++){
      state.currentSplitScenario.orig.push({ ...state.currentSplitScenario.form[i] });
    } */
  }
};

const clearFormResetState = (state: BuyerSplitSettingState) => {
  state.currentSplitScenario.orig = null;
};

const currentSplitScenarioState = (
  newForm: Array<BuyerSplitSetting>,
  state: BuyerSplitSettingState,
  action: any,
) => {
  let totalSplits: number = 0;

  let filteredForm: Array<BuyerSplitSetting> = newForm.filter(
    (splitSetting: BuyerSplitSetting) =>
      !(isNaN(splitSetting.BuyerId) || isNaN(splitSetting.BuyerGroupId)),
  );

  filteredForm.forEach((item, idx, arr) => {
    //item.SplitValue = isNaN(item.SplitValue) ? 0 : item.SplitValue;
    totalSplits += isNaN(item.SplitValue) ? 0 : item.SplitValue * 1;
  });

  return {
    ...state,
    currentSplitScenario: {
      ...state.currentSplitScenario,
      form: filteredForm,
      totalSplits: totalSplits
    },
    editEntry: null
  };
};
